import {
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '../ui/dialog';

export default function ConfirmDeleteModal({
    itemNome,
    onConfirm,
    titulo,
    descricao,
    textoConfirmar = 'Excluir',
}) {
    return (
        <DialogContent>
            <DialogHeader>
                <DialogTitle>{titulo ?? `Excluir ${itemNome}?`}</DialogTitle>
            </DialogHeader>
            <DialogDescription>
                {descricao ?? `Todos os dados associados com ${itemNome} serão removidos.`}
            </DialogDescription>
            <DialogFooter>
                <DialogClose asChild>
                    <button
                        type="button"
                        className="bg-red-600/70 py-2 px-4 rounded-md hover:bg-red-600 hover:cursor-pointer border-slate-800 border-2 transition-all duration-200 ease-in-out"
                        onClick={onConfirm}
                    >
                        {textoConfirmar}
                    </button>
                </DialogClose>
            </DialogFooter>
        </DialogContent>
    );
}
